import { RequestService, type RequestOptions } from '../request-service';
import type RpcModule from '@wix/ambassador-devcenter-marketplace-v1-web-solution/rpc';
import type HttpModule from '@wix/ambassador-devcenter-marketplace-v1-web-solution/http';
import type {
  AppMarketRecommenderRequest,
  AppMarketRecommenderResponse,
} from '@wix/ambassador-devcenter-marketplace-v1-web-solution/types';

type RpcModuleType = typeof RpcModule;
type HttpModuleType = typeof HttpModule;

export class AppsRecommenderService extends RequestService<
  RpcModuleType,
  HttpModuleType
> {
  protected async rpcModule(): Promise<RpcModuleType> {
    return import('@wix/ambassador-devcenter-marketplace-v1-web-solution/rpc');
  }

  protected async httpModule(): Promise<HttpModuleType> {
    return import('@wix/ambassador-devcenter-marketplace-v1-web-solution/http');
  }

  public async getAppsRecommender(
    limit: number,
    languageCode?: string,
    options?: RequestOptions,
  ): Promise<string[]> {
    const response = await this.request<
      AppMarketRecommenderRequest,
      AppMarketRecommenderResponse
    >({
      methodName: 'appMarketRecommender',
      payload: {
        limit,
        lang: languageCode,
      },
      options,
    });

    return (
      response.webSolutions?.map(
        (webSolution) => webSolution?.baseInfo?.id ?? '',
      ) ?? []
    );
  }
}
